// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"__0pukt3zW","icon":"_gxW_Sqb","title":"I_wWcwLm","content":"f3QCcGQX","actions":"__01UKcdZC"};